import { motion } from "framer-motion";
import { heroLeft, heroRight } from "./animationVariants";

export default function ProgramHero({ program }) {
  return (
    <section className="max-w-6xl mx-auto px-4 md:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
        <motion.div {...heroLeft} className="lg:col-span-6">
          <div className="eyebrow mb-4">Programs · Integrated Clinical Intelligence</div>
          <h1 className="font-display font-bold tracking-[-0.04em] leading-[1.0] text-[clamp(2.5rem,5.5vw,4.5rem)]">
            {program.title.split(" ").slice(0, -1).join(" ")}{" "}
            <span className="gold-shimmer">
              {program.title.split(" ").slice(-1)}
            </span>
          </h1>
          <p className="mt-6 text-xl md:text-2xl text-foreground/80 leading-relaxed">
            {program.pitch}
          </p>
        </motion.div>

        <motion.div {...heroRight} className="lg:col-span-6">
          <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden border-2 border-primary/25 gold-glow">
            <img
              src={program.image}
              alt={`${program.title} — Integrated Clinical Intelligence`}
              data-testid={`program-hero-image-${program.slug}`}
              className="w-full h-full object-cover"
              loading="eager"
              style={{ filter: "brightness(1.05) contrast(1.05) saturate(1.1)" }}
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-foreground/30 via-transparent to-transparent" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
